// src/services/PromotionModuleSettingsService.js

const API_BASE = '/promotions_module_settings';

export async function getPromotionModuleStatus() {
  const response = await fetch(`${API_BASE}/status`, {method: "GET"});
  console.log(response);
  return response;
}

export async function togglePromotionModule() {
  const response = await fetch(`${API_BASE}/toggle`, { method: 'POST' });
  return response;
}

